// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"49a40041","144":"4961ed75","258":"d6f6e5c0","426":"e5ba41b0","556":"8f4fef05","623":"0e4df2c2","787":"1622b7c0","961":"bb7ff224"}[chunkId] + ".chunk.js";
};